import Icon from '../components/Icon.vue'

Icon.register({
  'map-marked-alt': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M288 0C218.4 0 162 56.4 162 126 162 182.3 244.3 284.8 275.9 322 282.3 329.6 293.7 329.6 300.1 322 331.6 284.8 414 182.3 414 126 414 56.4 357.6 0 288 0zM288 168C264.8 168 246 149.2 246 126S264.8 84 288 84 330 102.8 330 126 311.2 168 288 168zM20.1 215.9A32-32 0 0 1 0 245.7V496C0 507.3 11.4 515 21.9 510.8L160 448V214.9C151.2 198.9 143.9 183.4 138.8 168.5L20.1 215.9zM288 359.7C273.9 359.7 260.6 353.5 251.5 342.7 231.8 319.5 210.9 293.1 192 266V448L384 512V266C365.1 293.1 344.2 319.5 324.5 342.7 315.4 353.5 302.1 359.7 288 359.7zM554.1 161.2L416 224V512L555.9 456.1A32-32 0 0 1 576 426.3V176C576 164.7 564.6 157 554.1 161.2z'
      }
    ]
  }
})
